import { getByteLen, isEmpty, formatDate, isNumber } from '@/common/js/utils'

function validateName(rule, value, callback) {
  const { plan_name } = this.innerForm
  if (!plan_name) {
    callback(new Error('请输入计划组名称'))
  }
  const len = getByteLen(plan_name)
  if (len > 80) {
    callback(new Error('最大80个字符，1个中文等于2个字符'))
  }
  callback()
}

function validateCampaignId(rule, value, callback) {
  const { campaign_id, batch_task_type } = this.formData
  if (!campaign_id && batch_task_type === 1) {
    callback(new Error('请选择计划名称'))
  }
  callback()
}
function validateTitle(rule, value, callback) {
  const { titleList } = this.formData.creativeForm
  if (!titleList && !titleList.length) {
    callback(new Error('请选择标题'))
  } else if (titleList.some((met) => !met.title)) {
    callback(new Error('标题不能为空'))
  } else if (titleList.some((met) => getByteLen(met.title) > 60)) {
    callback(new Error('每个标题长度不能超过60个字符'))
  }
  callback()
}
function validateFtypes(rule, value, callback) {
  const { ftypes, scene } = this.formData.creativeForm
  if (scene === 2 && !ftypes.length) {
    callback(new Error('场景选择投放位不能为空'))
  }
  callback()
}
function validateUserPortrait(rule, value, callback) {
  const { userPortrait } = this.formData.creativeForm
  if (!userPortrait) {
    callback(new Error('品牌头像不能为空'))
  }
  callback()
}
function validateBrand(rule, value, callback) {
  const { brand } = this.formData.creativeForm
  if (!brand) {
    callback(new Error('品牌名称不能为空'))
  } else if (brand.length > 11) {
    callback(new Error('品牌名称最多11个字'))
  }
  callback()
}
function validateSubtitle(rule, value, callback) {
  const { subtitle } = this.formData.creativeForm
  if (!subtitle) {
    callback(new Error('副标题不能为空'))
  } else if (getByteLen(subtitle) > 24) {
    callback(new Error('副标题最多24个字符'))
  }
  callback()
}
function validateCreatives(rule, value, callback) {
  const { videoCreative, largeCreative, imageCreative, groupCreative, creativeDetails } = this.formData.creativeForm
  const creatives = [...videoCreative, ...largeCreative, ...imageCreative, ...groupCreative]
  if (!creatives.length) {
    callback(new Error('创意素材不能为空'))
  } else {
    creatives.map((creative) => {
      let errMsg
      const err = creative.template.map((met) => {
        let stat
        if (['image', 'video', 'cover'].includes(met.name)) {
          if (met.required && isEmpty(met[met.name])) stat = false
          else if (['image', 'cover'].includes(met.name)) {
            let fileSize, Width, Height
            const { size: file_size, width, height } = met.restriction
            const index = creativeDetails.findIndex((ret) => ret.image_token === met[met.name])
            const {
              type,
              file_size: realFileSize,
              width: fileWidth,
              height: fileHeight,
              cover_size: coverSize,
              cover_width: coverWidth,
              cover_height: coverHeight
            } = creativeDetails[index]
            if (type === 'video') {
              // 默认封面
              fileSize = coverSize
              Width = coverWidth
              Height = coverHeight
            } else {
              fileSize = realFileSize
              Width = fileWidth
              Height = fileHeight
            }
            if (fileSize > file_size * 1024 || width !== Width || height !== Height) {
              stat = false
              errMsg = `${type === 'video' ? '视频封面' : '图片'}尺寸超出限制，请逐个检查选择`
            } else stat = true
          } else if (met.name === 'video') {
            const { file_size, width, height } = met.restriction
            const index = creativeDetails.findIndex((ret) => ret.photo_id === met[met.name])
            const { file_size: fileSize, width: Width, height: Height } = creativeDetails[index]
            if (fileSize > file_size * 1024 || Width !== width || Height !== height) {
              stat = false
              errMsg = '视频封面尺寸超出限制，请逐个检查选择'
            } else stat = true
          }
        } else if (['package'].includes(met.name)) {
          stat = met.children.every((t) => {
            return t.required ? !isEmpty(t[t.name]) : true
          })
        }
        return stat
      })
      if (err.some((e) => !e)) callback(new Error(errMsg))

      if (groupCreative.length) {
        const isFullGroup = groupCreative.every((g) => {
          const templateChildren = g.template[0].children
          return templateChildren[0].image1 && templateChildren[1].image2 && templateChildren[2].image3
        })
        if (!isFullGroup) callback(new Error('组图必须填满三张图，请逐个检查'))
      }
    })
  }
  callback()
}

function validateBid(rule, value, callback) {
  const { bid_range, ocpcBid, bid_num_range } = this.outterForm.ocpc

  // 固定出价
  if (bid_range === 0) {
    if (ocpcBid < 0.4 || ocpcBid >= 100000) {
      return callback(new Error('出价应大于0.3且小于100000'))
    }
  }
  // 随机出价
  if (bid_range === 1) {
    const [min, max] = bid_num_range
    if (isEmpty(min) || isEmpty(max)) return callback(new Error('出价不能为空'))
  }

  callback()
}

function validateDeepBid(rule, value, callback) {
  const { transType, ocpcBid, deep_bid_mode, deep_bid_range, deep_deepbid_num_range, deepOcpcBid, roiRatio } = this.outterForm.ocpc
  // 深度转化出价[付费]
  if (deep_bid_mode && transType === 26) {
    if (isEmpty(roiRatio)) return callback(new Error('roi系数不能为空'))
    if (!isNumber(roiRatio)) return callback(new Error('请输入数字'))
    if (roiRatio < 0 || roiRatio > 100) return callback(new Error('roi系数区间范围0.01 - 100'))
  }

  // 深度转化出价[激活]
  if (deep_bid_mode && transType === 4) {
    // 固定出价
    if (deep_bid_range === 0) {
      if (isEmpty(deepOcpcBid)) return callback(new Error('出价不能为空'))
      if (deepOcpcBid < 0.4 || deepOcpcBid >= 100000) return callback(new Error('出价应大于0.3且小于100000'))
      if (ocpcBid && ocpcBid >= deepOcpcBid) return callback(new Error('深度转化出价应大于目标转化出价'))
    }

    // 随机出价
    if (deep_bid_range === 1) {
      const [min, max] = deep_deepbid_num_range
      if (isEmpty(min) || isEmpty(max)) return callback(new Error('出价不能为空'))
      if (min >= max) return callback(new Error('随机出价前值应小于后值'))
      if (ocpcBid && Math.min(min, max) <= ocpcBid) return callback(new Error('随机出价应大于目标转化出价'))
    }
  }

  callback()
}
function validateUrl(rule, value, callback) {
  const { lpUrl, innerUrl } = this.outterForm.ocpc
  const urlRegExp = /^(https?:\/\/(([a-zA-Z0-9]+-?)+[a-zA-Z0-9]+\.)+[a-zA-Z]+)(:\d+)?(\/.*)?(\?.*)?(#.*)?$/

  if (!innerUrl) {
    if (isEmpty(lpUrl)) return callback(new Error('推广落地页不能为空'))

    if (!urlRegExp.test(lpUrl)) return callback(new Error('推广落地页链接地址不正确'))
  }

  callback()
}
function validateTrans(rule, value, callback) {
  const { transFromTypeName } = this.convert_params

  if (!transFromTypeName) {
    return callback(new Error('转化类型不能为空'))
  }

  callback()
}

export function makeBasicRules() {
  return {
    plan_name: [{ required: true, validator: validateName.bind(this), trigger: 'change' }],
    campaign_id: [{ required: true, validator: validateCampaignId.bind(this), trigger: 'change' }]
  }
}

export function makeStreamRules() {
  return {
    transFromTypeName: [{ required: true, validator: validateTrans.bind(this), trigger: 'change' }]
  }
}
export function makeBudgetRules() {
  return {
    bid: [{ required: true, validator: validateBid.bind(this), trigger: 'change' }],
    'deep-bid': [{ required: true, validator: validateDeepBid.bind(this), trigger: 'change' }],
    lpUrl: [{ required: true, validator: validateUrl.bind(this), trigger: 'change' }]
  }
}
export function makeCreativeRules() {
  return {
    title: [{ required: true, validator: validateTitle.bind(this), trigger: 'change' }],
    ftypes: [{ required: true, validator: validateFtypes.bind(this), trigger: 'change' }],
    brand: [{ required: true, validator: validateBrand.bind(this), trigger: 'change' }],
    subtitle: [{ required: true, validator: validateSubtitle.bind(this), trigger: 'change' }],
    creatives: [{ required: true, validator: validateCreatives.bind(this), trigger: 'change' }],
    userPortrait: [{ required: true, validator: validateUserPortrait.bind(this), trigger: 'change' }]
  }
}
